module.exports = __webpack_public_path__ + "4d467fff945db6b33531013bc4fe9e3b.fbx";